import { MoreVertical } from 'lucide-react';
import { Area, AreaChart, Line, LineChart, ResponsiveContainer } from 'recharts';
const viewsData = [
    { month: 'Jan', value: 30 },
    { month: 'Feb', value: 45 },
    { month: 'Mar', value: 35 },
    { month: 'Apr', value: 50 },
    { month: 'May', value: 40 },
    { month: 'Jun', value: 55 },
    { month: 'Jul', value: 65 },
    { month: 'Aug', value: 45 }
];

const accountsData = [
    { month: 'Jan', value: 30 },
    { month: 'Feb', value: 45 },
    { month: 'Mar', value: 55 },
    { month: 'Apr', value: 48 },
    { month: 'May', value: 60 },
    { month: 'Jun', value: 52 },
    { month: 'Jul', value: 65 },
    { month: 'Aug', value: 58 }
];

const campaignData = [
    { month: 'Jan', value: 20 },
    { month: 'Feb', value: 35 },
    { month: 'Mar', value: 45 },
    { month: 'Apr', value: 25 },
    { month: 'May', value: 50 },
    { month: 'Jun', value: 40 },
    { month: 'Jul', value: 70 },
    { month: 'Aug', value: 45 }
];

function BottomRow() {
    return (<div className="grid grid-cols-3 gap-6">
        {/* Campaign Stats */}
        <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-white text-lg font-semibold">Campaign Stats</h3>
                <MoreVertical className="text-slate-400" size={20} />
            </div>
            <div className="space-y-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-pink-500 rounded-lg flex items-center justify-center">📱</div>
                        <span className="text-white">Campaigns</span>
                    </div>
                    <div className="text-right">
                        <span className="text-white font-semibold">54</span>
                        <span className="text-emerald-400 text-sm ml-2">28%</span>
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center">✉️</div>
                        <span className="text-white">Emails</span>
                    </div>
                    <div className="text-right">
                        <span className="text-white font-semibold">82</span>
                        <span className="text-emerald-400 text-sm ml-2">15%</span>
                    </div>
                </div>
            </div>
            <ResponsiveContainer width="100%" height={100} className="mt-4">
                <LineChart data={campaignData}>
                    <Line type="monotone" dataKey="value" stroke="#22c55e" strokeWidth={2} dot={false} />
                </LineChart>
            </ResponsiveContainer>
        </div>

        {/* Total Views */}
        <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50">
            <div className="flex items-center justify-between mb-2">
                <div>
                    <h3 className="text-white text-lg font-semibold">68.4K</h3>
                    <p className="text-slate-400 text-sm">Total Views</p>
                </div>
                <MoreVertical className="text-slate-400" size={20} />
            </div>
            <ResponsiveContainer width="100%" height={120}>
                <LineChart data={viewsData}>
                    <Line type="monotone" dataKey="value" stroke="#ec4899" strokeWidth={2} dot={{ fill: '#ec4899', r: 4 }} />
                </LineChart>
            </ResponsiveContainer>
            <p className="text-emerald-400 text-sm mt-2">35% users increased from last month</p>
        </div>

        {/* Total Accounts */}
        <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50">
            <div className="flex items-center justify-between mb-2">
                <div>
                    <h3 className="text-white text-2xl font-bold">85,247</h3>
                    <p className="text-slate-400 text-sm">Total Accounts</p>
                </div>
                <span className="text-emerald-400 text-sm">↓ 23.7%</span>
            </div>
            <ResponsiveContainer width="100%" height={150}>
                <AreaChart data={accountsData}>
                    <defs>
                        <linearGradient id="colorAccounts" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="#7c2d12" stopOpacity={0.2} />
                        </linearGradient>
                    </defs>
                    <Area type="monotone" dataKey="value" stroke="#f59e0b" strokeWidth={2} fill="url(#colorAccounts)" />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    </div>);
}

export default BottomRow;